import { useEffect, useState } from 'react'
import { Row, Col, Button, Container, Alert } from 'react-bootstrap'
import { AiFillCheckCircle } from 'react-icons/ai'
import { BsFillCalendar3EventFill } from 'react-icons/bs'
import { useDispatch, useSelector } from 'react-redux';
import { MdPerson, MdGroups } from 'react-icons/md'

import { useNavigate } from 'react-router-dom';
import API from "../../api/api";
import Actions from '../../redux/actions';

export default function UsageType(props) {

    const packageType = useSelector(state => state.packageType)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [usageType, setUsageType] = useState('')

    useEffect(() => {
    }, [])


   

    const _select = async () => {
        dispatch(Actions.setUsageType(usageType))
        if(usageType === 'ME'){
            dispatch(Actions.setSignupStep(7))
        }else{
            dispatch(Actions.setSignupStep(6))
        }
    }


    return (
        <Container className='p-4 text-center'>
            <Row>
                <Col md={8} className={`bg-white shadow rounded my-auto mx-auto animate__animated animate__fadeIn text-center `}>
                    <div className='p-3'>            
                        <div className='p-3'>
                            <h1 className='display-4 text-primary font-weight-bold'><b>How Will You Be Using ScamWall?</b></h1>
                            <Row className='mt-5'>
                                <Col>
                                    <div className={`h-100 shadow border rounded pointer p-3 text-center ${usageType === 'ME' && 'border-primary'}`} onClick={() => setUsageType('ME')}>
                                        <h3 className='text-primary'>Just Yourself</h3>
                                        <MdPerson className='text-primary' size='5rem' />
                                        <p className='m-0 p-0 mt-3'>You will be protecting your devices from this account </p>
                                    </div>
                                </Col>
                                <Col>
                                    <div className={`h-100 shadow border rounded pointer p-3 text-center ${usageType === 'OTHER' && 'border-primary'}`} onClick={() => setUsageType('OTHER')}>
                                        <h3 className='text-primary'>Admin For Others</h3><br />
                                        <MdGroups className='text-primary' size='5rem' />
                                        <p className='m-0 p-0 mt-3'>You will be protecting family's/friend's/other's and/or your devices from this account </p>
                                    </div>
                                </Col>
                            </Row>
                            <Button variant='primary text-white' onClick={_select} disabled={usageType === ''} className='w-100 mt-4'>Next</Button>
                        </div>

                    </div>
                </Col>
            </Row>
        </Container>
    )
}